import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';
import { toast } from 'react-toastify';
import { removeLastExtension } from '../../../helpers/removeExtension';

const { setDeployData, setDeployStatus } = slice.actions;

const getDeploy = (url: any, params: any) => async () => {
  try {
    const response = await API.deploy.getDeploy(url, params);
    dispatch(setDeployData(response.data));
    dispatch(setDeployStatus(response.status));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    toast.error(removeLastExtension(error?.response.data.message));
  }
};

export default {
  getDeploy
};
